export const ENUM_API = `v1/enums`